<template>
	<div class="IdentityCompanyLCE" >
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-enterprise Icon"></i>
			<!-- <span class="p-l-10 p-r-10">/</span> -->
			<span class="header_text">/ 企业管理 / 签约费率&amp;结算通道</span>
		</div>
		<div class="companybox content_Box box-shadow m-t-15 p-l-10 p-r-10" :style="{'min-height': windowSizeHeight-120 +'px'}">
			<div class="headerBox">
				资质材料
			</div>
			<div class="p-t-10 p-b-10">
				<div class="row-info clear">
					<div class='fl title-key'>签约日期</div>
					<div class='fl list-cont'>{{enterpriseInfo.contract_time_start}}</div>
				</div>
				<div class="row-info clear">
					<div class='fl title-key'>终止日期</div>
					<div class='fl list-cont'>{{enterpriseInfo.contract_time_end}}</div>
				</div>
				<div class="row-info clear">
					<div class='fl title-key'>签约费率</div>
					<div class='fl list-cont'>
						<div v-for="(item,index) in enterpriseInfo.contract_rate" :key="index">
							<span class="font-Tahoma " >{{ item.start | toFixed2 |filterNumber }} <a>元</a> &lt; </span>
							<span class="font-Tahoma  p-l-40 p-r-40" >—</span>
							<span class="font-Tahoma" >&lt;= {{ item.end | toFixed2 | filterNumber }}
								<a v-if="index != enterpriseInfo.contract_rate.length-1">元</a>
							</span>
							<span class="font-Tahoma p-l-40 p-r-40">,</span>
							<span class="font-Tahoma">{{ item.rate }} %</span>
						</div>
					</div>
				</div>
				<div class="clear"></div>
			</div>
			

		</div>


	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	import {
		publicData
	} from '../assets/js/data.js';
	export default {
		name: 'IdentityCompanyLCE',
		data() {
			return {
				url: common.url,
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				enterpriseInfo: '', //企业信息
				balanceShow:false, //支付通道
				js_Show:false, //通道
			}
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {
				if (!sessionStorage.getItem('userInfo')) { //是否登录
					window.location = 'login.html';
					return;
				}
				this.getEnterpriseOne();
			},
			getEnterpriseOne() { //获取企业信息
				this.$http.post(this.url + '/zhongfy/company/EnterpriseOne').then((res) => {
					if (res.data.msg == '成功' || res.data.code == '200') {
						let enterpriseInfo = res.data.data;
						let contract_rate = JSON.parse(enterpriseInfo.contract_rate);
						for(let i = 0 ;i< contract_rate.length ; i++){
							contract_rate[i].rate = (contract_rate[i].rate*100).toFixed(2);
						}
						enterpriseInfo.contract_rate = contract_rate;
						this.signRateArr= contract_rate;
						this.enterpriseInfo = enterpriseInfo;
						console.log(this.enterpriseInfo)
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error(res.data.msg);
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			},

		},
		filters: {
			contract_rate(val) { //费率转换
				if (!val) return '';
				let result = val * 100;
				if (result % 1 === 0) {
					return result;
				} else {
					return result.toFixed(2);
				}

			},
			toFixed2(val){
				if(!val) return '';
				if(val=='max') return val;
				let num = Number(val).toFixed(2);
				return num
			},
			filterNumber(value) { //过滤金钱加,
				if (!value) return '0.00';
				if (value == 'max') return value;
				var intPart = Number(value) - Number(value) % 1; //获取整数部分（这里是windy93的方法）
				var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
				var floatPart = ".00"; //预定义小数部分
				var value2Array = value.toString().split(".");
				//=2表示数据有小数位
				if (value2Array.length == 2) {
					floatPart = value2Array[1].toString(); //拿到小数部分
					if (floatPart.length == 1) { //补0,实际上用不着
						return intPartFormat + "." + floatPart + '0';
					} else {
						return intPartFormat + "." + floatPart;
					}
				} else {
					return ( Number(intPartFormat) + Number(floatPart) ).toFixed(2);
				}
			},

		}


	}
</script>

<style scoped>

	.companybox .headerBox {
		height: 35px;
		line-height: 35px;
		font-size: 16px;
		padding-left: 10px;
		border-bottom: 1px solid #E8E8E8;
		font-weight: 700;
		color: #333333;
	}
	.contentInfo>div{
		width: 100px;
		height: 30px;
		border:2px solid var(--theme-red);
		padding:5px;
		position: relative;
	}
	.contentInfo .ws-url{
		width: 100%;
	}
	.contentInfo .ws-ok{
		width: 18px;
		position: absolute;
		right: 0;
		bottom: 0;
	}



</style>



// WEBPACK FOOTER //
// src/components/IdentityCompanyLCE.vue